import React, { Component } from 'react';
import { ProgressBar } from 'react-bootstrap';
import AsyncSelect from 'react-select3/async';
import request from 'superagent';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class ClioClientSelector extends Component {
  static defaultProps = {
    connectionId: null,
  };

  static propTypes = {
    connectionId: PropTypes.number.isRequired,
  };

  state = {
    isLoading: false,
    isRefreshing: false,
  };

  render() {
    const {isLoading, isRefreshing, clientSelectOptions} = this.state;

    if (isLoading && !clientSelectOptions) return (
      <ProgressBar now={100}/>
    );

    const refreshClasses = classNames({
      'fa': true,
      'fa-refresh': true,
      'fa-spin': isRefreshing,
    })

    return (
      <div key="self" style={{position: 'relative'}}>
        <AsyncSelect
          cacheOptions
          key={this.props.value}
          defaultOptions
          loadOptions={this.loadClients}
          noOptionsMessage={() => 'Type to search clients...'}
          placeholder='Search Clients...'
          loadingMess
          isClearable
          getOptionLabel={option => option.name}
          getOptionValue={option => option.id}
          {...this.props}
        />
        <i className={refreshClasses}
          style={{
            position: 'absolute',
            textAlign: 'center',
            top: '12px',
            right: '27px',
            zIndex: 100,
            cursor: 'pointer',
          }}
          onClick={() => this.loadClients(true)}
          key="client-refresh-button"
        />
      </div>
    );
  }

  loadClients = (inputValue) => {
    const { connectionId, initialClientId } = this.props;

    if (!inputValue && initialClientId) {
      return request.get(`/rpc/integrations/connections/${connectionId}/clio/clients/${value}`)
        .then(response => [response.body.data]);
    }
    else {
      return request.get(`/rpc/integrations/connections/${connectionId}/clio/clients`)
        .query({ query: inputValue })
        .then(response => response.body.data);
    }
  }
}

/**
 * Final Form compatible component adapter
 * Can be used as:
 *  <Field name="client_id">
 *    {props =>
 *      <ClioClientSelector
 *        input={props.input}
 *        connectionId={connectionId}
 *      />
 *    }
 *  </Field>
 */
export const FinalFormClioClientSelector = ({ input: { value, onChange }, ...rest }) => {
  // NOTE does not work for Async select in react-select3 because we dont have the values yet...
  return (
    <ClioClientSelector
      //value={value}
      onChange={selectedClient => onChange(_.get(selectedClient, 'id'))}
      {...rest}
    />
  ); };



// WEBPACK FOOTER //
// ./src/CaseFolder/Integrations/Clio/ClioClientSelector.jsx